import { useTranslation } from "react-i18next";
import commonStyles from "../../common/css/Common.module.css";
import {useDialog} from "../../common/hook/DialogContext";

const CustomConfirm = () => {
    const {confirms, removeConfirm} = useDialog();
    const {t} = useTranslation();

    return (
        confirms.map(confirm => (
            <div className={commonStyles.dialog_wrap}>
                <div>
                    <div className={commonStyles.middle}>
                        {confirm.message}
                    </div>
                    <div className={commonStyles.bottom}>
                        <div className={commonStyles.btns}>
                            <a
                                href="#"
                                className={commonStyles.cc_btn}
                                onClick={
                                    (e) => {
                                        e.preventDefault();
                                        removeConfirm(confirm.id);
                                        confirm.afterConfirm();
                                    }
                                }
                            >
                                {/* {confirm.message == 'would you like to' ?
                                    <span>{t("challenge.menu.team.submit")}</span>
                                    : */}
                                    <span>{t("common.submit")}</span>
                                {/* } */}
                                
                            </a>
                            <a
                                href="#"
                                className={`${commonStyles.cc_btn} ${commonStyles.bg_white}`}
                                onClick={
                                    (e) => {
                                        e.preventDefault();
                                        removeConfirm(confirm.id);
                                        confirm.afterCancel();
                                    }
                                }
                            >
                                <span>{t("common.cancel")}</span>
                            </a>
                        </div>
                    </div>
                    <button
                        type="button"
                        className={commonStyles.md_close_btn}
                        onClick={
                            () => {
                                removeConfirm(confirm.id);
                                confirm.afterCancel();
                            }
                        }
                    >
                        <span className={commonStyles.sr_only}>{t("common.closePop")}</span>
                    </button>
                </div>
            </div>
        ))
    );
};

export default CustomConfirm;